import axios from 'axios';
//const BASE_URL = 'http://localhost:8080'; // localhost
const BASE_URL = 'https://qstaff.farmailuzji.pl:7999'; // Farma


export default axios.create({
    baseURL: BASE_URL
});


export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});


export const axiosPrivateFileUpload = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'multipart/form-data' },
  withCredentials: true
  }

)
